/*
 * Public API Surface of capiche-disclosure-path
 */

export * from './lib/disclosure-path.service';
